import React, { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import resetPasswordFormData from "./ResetPasswordForm.data";
import ToastService from "../../services/toastService/ToastService";
import { useNavigate, Link } from "react-router-dom";

const ResetPasswordForm = () => {
  const resetFormRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = () => {
    const formData = resetFormRef.current?.getFormData();
    if (!formData) return;

    setIsLoading(true);
    // Simulate reset password API request
    setTimeout(() => {
      setIsLoading(false);
      ToastService.success(
        "Your password has been reset successfully.",
        "Success"
      );
      navigate("/login");
    }, 1500);
  };

  return (
    <div className="login-form-section">
      <FormCreator
        ref={resetFormRef}
        {...resetPasswordFormData}
      />
      <div className="button-part">
        <Buttons
          buttonTypeClassName="btn success-btn"
          buttonText="Continue"
          onClick={handleResetPassword}
          isLoading={isLoading}
        />
      </div>
      <div className="text-center mt-3">
        <Link
          to="/login"
          className="font-medium text-[#329a03] hover:text-[#297407] text-sm"
        >
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
